import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, map, catchError, finalize } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { UpdateCaseTypeResult } from './update-case-type.result';
import { UpdateCaseTypeCommand } from './update-case-type.command';

@Injectable({ providedIn: 'root' })
export class UpdateCaseTypeUseCase {
  private readonly _repository = inject(CaseTypeRepository);
  private readonly _state = inject(CaseTypeState);

  public execute(id: string, params: UpdateCaseTypeCommand): Observable<UpdateCaseTypeResult> {
    this._state.setSaving(true);
    this._state.clearError();

    return this._repository.updateCaseType(id, params).pipe(
      switchMap(() =>
        this._repository.getAllCaseTypes().pipe(
          map((caseTypes) => {
            this._state.setCaseTypes(caseTypes);
            return { success: true };
          }),
        ),
      ),
      catchError((error) => {
        throw error;
      }),
      finalize(() => {
        this._state.setSaving(false);
      }),
    );
  }
}
